import Vue from 'vue'

Vue.config.productionTip = false
Vue.prototype.$APP_COD = require('../../package.json').appKey
Vue.prototype.$APP_VER = require('../../package.json').version
Vue.prototype.$APP_NAM = require('../../package.json').name
